<template>
  <div v-if="!model || !model.$disabled">
    <label v-if="model && getTitle">
      <w-next-number v-bind="nextNumber" v-if="nextNumber" />
      {{getTitle}}
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{tooltipContent}}</w-tooltip>
    </label>
    <w-description v-if="model" :model="model" v-bind="description">
      <slot name="description" />
    </w-description>
    <w-error v-if="model && model != {}" :model="model"></w-error>
    <table :class="tableClass" :style="margin ? 'margin-bottom: 2em;' : ''" ref="table">
      <thead ref="header">
        <slot name="thead"></slot>
      </thead>
      <slot></slot>
    </table>
    <table v-if="this.floatingHeader" v-show="floats" :class="[tableClass]" :style="floatingStyle">
      <thead ref="floating_header">
        <slot name="thead"></slot>
      </thead>
    </table>
  </div>
</template>

<script>
import WError from './error.vue';
import modelMixin from '../mixins/modelMixin';

export default {
  name: 'w-form-table',
  mixins: [modelMixin],
  props: {
    css: {
      type: String,
      default: 'table table-bordered table-fixed-header noborderdisabled valigntop'
    },
    model: Object,
    // aby floating header dobrze wyglądał - wszystkie th muszą mieć width
    floatingHeader: {
      type: Boolean,
      default: false
    },
    description: {
      type: Object,
      default: () => ({
        value: '',
        tooltip: false,
        htmlContent: false
      }),
      required: false
    },
    nextNumber: {
      type: Object,
      default: null,
      // default: () => ({
      //   level: null,
      //   value: null,
      //   type: null
      // }),
      required: false
    },
    margin: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      headerHeight: 0,
      windowY: 0,
      tableY: 0,
      tableHeight: 0,
      tableWidth: 0,
      fixedWidth: [],
      lastRowHeight: 0,
      penultimateRowHeight: 0
    };
  },
  components: {
    WError
  },
  methods: {
    getPositionY(elem) {
      let y = 0;
      if (elem && !isNaN(elem.offsetLeft) && !isNaN(elem.offsetTop)) {
        y += elem.offsetTop - elem.scrollTop;
        y += this.getPositionY(elem.offsetParent);
      }
      return y;
    },
    getCells(elem) {
      let cells = elem.querySelectorAll('th');
      if (cells.length === 0) {
        cells = elem.querySelectorAll('td');
      }
      return cells;
    },
    scroll() {
      if (!this.$refs || !this.$refs.table || !this.$refs.header || !this.$refs.floating_header) {
        return null;
      }
      this.windowY = window.scrollY || window.pageYOffset + 1;
      const table = this.$refs.table;
      this.headerHeight = this.$refs.header.clientHeight; // ref floating_header może zmieniać height
      const reck = table.getBoundingClientRect();
      this.tableY = reck.y || reck.top || (this.isIE ? this.getPositionY(table) : this.getPositionY(table) - this.windowY);
      this.tableWidth = reck.width;
      this.tableHeight = reck.height;
      const floatingCells = this.getCells(this.$refs.floating_header);
      const headerCells = this.getCells(this.$refs.header);

      const rows = this.$refs.table.querySelectorAll('tr');
      if (rows && rows.length > 1) {
        this.lastRowHeight = rows[rows.length - 1].getBoundingClientRect().height;
        if (rows.length > 2) {
          this.penultimateRowHeight = rows[rows.length - 1].getBoundingClientRect().height;
        } else {
          this.penultimateRowHeight = this.lastRowHeight;
        }
      } else {
        this.penultimateRowHeight = this.headerHeight;
        this.lastRowHeight = this.headerHeight;
      }
      for (let i = 0; i < floatingCells.length; i++) {
        const rect = headerCells[i].getBoundingClientRect();
        floatingCells[i].removeAttribute('width');
        const computedStyle = window.getComputedStyle(headerCells[i]);
        const pl = parseFloat(computedStyle.paddingLeft) || 0;
        const pr = parseFloat(computedStyle.paddingLeft) || 0;
        const br = parseFloat(computedStyle.borderRight) || 0;
        const bl = parseFloat(computedStyle.borderLeft) || 0;
        floatingCells[i].style.width = `${rect.width - pl - pr + (i !== 0 ? br : 0) + bl}px`;
      }
    }
  },
  created() {
    if (this.floatingHeader) {
      window.addEventListener('scroll', this.scroll.bind(this));
      window.addEventListener('resize', this.scroll.bind(this));
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.scroll);
    window.removeEventListener('resize', this.scroll);
  },
  computed: {
    isIE() {
      return window.navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
    },
    floats() {
      return (
        this.floatingHeader && this.tableY < 0 && this.tableHeight + this.tableY > 0 && this.tableHeight > this.lastRowHeight + this.penultimateRowHeight + this.headerHeight + 1
      );
    },
    top() {
      const position = !this.floats
        ? 0
        : this.tableHeight + this.tableY > this.lastRowHeight + this.penultimateRowHeight + this.headerHeight
        ? 0
        : this.tableHeight + (this.tableY - this.lastRowHeight - this.penultimateRowHeight - this.headerHeight);
      return position + 'px';
    },
    floatingStyle() {
      return {
        top: this.top,
        position: 'fixed !important',
        zIndex: 100000,
        width: this.tableWidth + 'px'
      };
    },
    tableClass: {
      get() {
        const arr = [this.css];

        if (this.model) {
          const vv = this.model.$value;
        }

        if (this.model && this.model.$error) {
          arr.push('state-error');
        } else {
          arr.push('state-success');
        }
        return arr;
      }
    }
  }
};
</script>

<style scoped>
table.floating {
  position: fixed !important;
  z-index: 100000;
  top: 0;
}
</style>